import React, { FC } from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import { Helmet } from "react-helmet";
import { AppRoute } from "routes";

const APP_TITLE: string | undefined = process.env.REACT_APP_TITLE;

type RouteWrapperProps = RouteComponentProps;

const RouteWrapper: FC<AppRoute> = (props: AppRoute) => {
  const { component: Component, layout, title, isPrivate, ...rest } = props;

  const Layout: FC<RouteWrapperProps | {}> = !layout ? ({ children }) => <>{children}</> : layout;

  return (
    <Route
      {...rest}
      render={(props: RouteWrapperProps) => (
        <Layout {...props}>
          {title && (
            <Helmet>
              <title>
                {APP_TITLE} - {title}
              </title>
            </Helmet>
          )}
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default RouteWrapper;
